import { Component, Inject, ViewContainerRef } from '@angular/core';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { AdminOrder } from '../../models/PurchaseOrder/create-purchase-order.model';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer/customer-model';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BulkChangeOrderStatus } from '../../models/order/order.model';
import { PurchaseOrderDetailView, POProducts } from '../../models/PurchaseOrder/purchase-order-detail-view.model';
import { Product } from '../../models/products/product.model';
@Component({
    selector: 'app-purchase-orders',
    templateUrl: './purchase-orders.component.html',
    styleUrls: ['./purchase-orders.component.scss']
})
/** purchase-orders component*/
export class PurchaseOrdersComponent {
  public orderList: AdminOrder[];
  //Filter items from grid
  filteredItems: any[];
  public customerList: Customer[];
  public rowsOnPage: number=10;
  public arrRowsPerPage: number[];
  public isEditAllowed: boolean = false;
  public orderDetail: PurchaseOrderDetailView;
  public purchaseOrderlist: PurchaseOrderDetailView[]=[];
  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public showBoundaryLinks: boolean;
  public isLoaded: boolean = false;
  public orderChangeForStatus: number[] = [];
  public sumQuantity: number;
  public total: number;
  public commissionTotal: number;
  public product: POProducts;
  public totalBalance: number;
  public searchKeyword: string = "";
  public orderDetailPrintComponent: string = "";
  public isChecked: boolean = false;
  public bulkOrderShipments: BulkChangeOrderStatus;
  /** purchase-orders ctor */
  constructor(private readonly orderService: PurchaseOrderService,
    private readonly utilitiesService: UtilitiesService,  public toastr: ToastsManager, vcr: ViewContainerRef,private readonly CustomerService: CustomerService, private readonly rolePermissionService: RolePermissionService,
    private _router: Router) {

    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.isLoaded = false;
    this.searchKeyword = "";
    this.showBoundaryLinks = true;
    this.orderDetailPrintComponent = '';
    this.rolePermissionService.GetRolePermissions("purchaseorderview").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (create.length > 0)
            this.isEditAllowed = true;
          if (list.length > 0) {
            this.bulkOrderShipments = new BulkChangeOrderStatus();
            this.toastr.setRootViewContainerRef(vcr);
            this.OnFilterChange();
            this.isChecked = false;

           // this.getOrders();
          //  this.GetRowsPerPageList();
         //   this.getVendors();
          }
          else {
            this._router.navigate(["/"]);
          }
        }
        else {
          this._router.navigate(["/"]);
        }
      }
    )
  }
  getOrders() {
    this.orderService.GetPurchaseOrders().subscribe(
      data => {
        this.orderList = data;
        this.filteredItems = data;
      });
  }
  getVendors() {
    this.CustomerService.getCustomer().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }

  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.orderList, searchText);

    } else {
      this.filteredItems = this.orderList;
    }
  }

  OnFilterChange() {
    this.pagenumber = 0;
  
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  OnFilterChangegrid() {
    this.isChecked = false;
    this.orderChangeForStatus = [];
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.orderService.GetPurchaseOrdersGrid(this.pagenumber, this.rowsOnPage,this.searchKeyword).subscribe(
      data => {
        this.isLoaded = true;
        this.orderList = data;
        if (this.orderList != null && this.orderList.length > 0)
          this.totalRecord = this.orderList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
  bulkselectStatus() {
    if (this.isChecked) {

      this.orderList.forEach(order => {
        this.orderChangeForStatus.push(order.purchaseOrderID);
        order.checked = true;
      });
    }
    else {
      this.orderChangeForStatus = [];
      this.orderList.forEach(order => {
        order.checked = false;
      });
    }
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.OnFilterChange();
    }
  }
  BulkListChangeStatus(orderID: number) {
    if (this.orderChangeForStatus.filter(i => i === orderID).length == 0) {
      this.orderChangeForStatus.push(orderID);
    }
    else {
      const index: number = this.orderChangeForStatus.indexOf(orderID);
      if (index !== -1) {
        this.orderChangeForStatus.splice(index, 1);
      }
    }
  }

  getSumAndQuantity(data: PurchaseOrderDetailView) {
    this.sumQuantity = 0;
    this.total = 0;
    this.commissionTotal = 0.00;
    this.totalBalance = 0.00;
    for (let i = 0; i < data.products.length; i++) {
      this.sumQuantity = this.sumQuantity + data.products[i].quantity;
      this.total = this.total + (data.products[i].quantity * data.products[i].unitBalance);
      this.commissionTotal = this.commissionTotal + data.products[i].unitComission;
      this.totalBalance = this.totalBalance + data.products[i].unitBalance;
    }

    this.commissionTotal = parseFloat((Math.round(this.commissionTotal * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);
    this.totalBalance = parseFloat((Math.round(this.totalBalance * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);
    this.sumQuantity = parseFloat((Math.round(this.sumQuantity * 100) / 100).toFixed(2));//parseFloat(Math.round(num3 * 100) / 100).toFixed(2);

  }


  OnbulkPrint(): void {
    if (this.orderChangeForStatus.length == 0) {
      this.toastr.error('Please select any order for Printing', 'Error');
      return;
    }
    this.bulkOrderShipments.orderIds = this.orderChangeForStatus;

    this.orderService.PrintOrder(this.bulkOrderShipments).subscribe(
      data => {
        this.purchaseOrderlist = data;

        var text = "";
        var counter = 0;
        var totalCounter = this.purchaseOrderlist.length;
        this.purchaseOrderlist.forEach(order => {
          this.sumQuantity = 0;
          this.total = 0;
          this.commissionTotal = 0.00;
          this.totalBalance = 0.00;
          this.getSumAndQuantity(order);
          this.orderDetailPrintComponent = '';
          for (var i = 0; i < order.products.length; i++) {
              this.product = new POProducts();
            this.product = order.products[i];
            this.orderDetailPrintComponent += '<tr><td class="item-holder name-col"><span>' + this.product.orderNumber + '</span></td><td class="item-holder name-col"><span>' + this.product.productSku + '</span></td><td class= "item-holder name-col"> ' + this.product.name + '</td><td class= "item-holder name-col"> ' + this.product.productArrtibuteFields + '<br />' + this.product.productArrtibuteValue + '</td><td class= "item-holder price-col" > ' + Math.round(this.product.unitPrice).toFixed(0) + '</td><td class="item-holder price-col"><span>' + Math.round(this.product.unitComission).toFixed(0) + '</span></td><td class="item-holder price-col" ><span>' + Math.round(this.product.unitBalance).toFixed(0) + '</span></td><td class="item-holder qntty-col"> ' + this.product.quantity + '</td><td class="item-holder price-col"><span>' + Math.round(this.product.unitBalance * this.product.quantity).toFixed(0) + '</span></td></tr>';

          }


          text = text + `
    <div class="order-summary-holder" id="print-section">
            <div class="header-section form-group">
              <img src="/Images/WebsiteImages/WebsiteLogo.jpg" class="invoice-img-show" alt="" width="250" style="float:right" />
              <div class="row">
                <div class="col-sm-6 heading-holder">
                  <strong class="customer-name">${order.vendor.vendorName}</strong>
                </div>
                <div class="col-sm-6 customer-holder text-right">
                  <ul class="order-short-details list-unstyled">
                    <li>
                      <strong>Phone No:</strong>
                      <span>${order.vendor.phoneNumber}</span>
                    </li>
                    <li>
                      <strong>Shop:</strong>
                      <span>${order.vendor.shopName}</span>
                    </li>
                    <li>
                      <strong>Order Date:</strong>
                      <span>${order.poDate}</span>
                    </li>
                    <li>
                      <strong>Order Status:</strong>
                      <span>${order.orderStatusName}</span>
                    </li>
                    <li>
                      <strong>Purchase Order No:</strong>
                      <span>${order.purchaseOrderId}</span>
                    </li>
                  </ul>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="address-block form-group">
              <div class="col-sm-12">
                <strong class="address-col-heading">Corporate office address</strong>
                <ul class="list-unstyled">
                  <li>
                    <strong>Address</strong>
                    <span>${order.vendor.address}</span>
                  </li>
                  <li>
                    <strong>City</strong>
                    <span>${order.vendor.city}</span>
                  </li>
                  <li>
                    <strong>State</strong>
                    <span>${order.vendor.state}</span>
                  </li>
                  <li>
                    <strong>Country</strong>
                    <span>${order.vendor.country}</span>
                  </li>
                </ul>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clear-fix"></div>
            <div class="row">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <table class="summary-table">
                    <thead>
                      <tr>
                        <th class="item-holder name-col">Order#</th>
                        <th class="item-holder name-col">Product SKU</th>
                        <th class="item-holder name-col">Product Name</th>
                        <th class="item-holder name-col">Attributes</th>
                        <th class="item-holder price-col">Price/Unit</th>
                        <th class="item-holder price-col">Commission/Unit</th>
                        <th class="item-holder price-col">Balance/Unit</th>
                        <th class="item-holder qntty-col">Quantity</th>
                        <th class="item-holder name-col">Price Total</th>
                      </tr>
                    </thead>
                    <tbody>
                        ${this.orderDetailPrintComponent}
                      <tr>
                        <td></td>
                        <td></td>
                         <td></td>
                        <td></td>
                        <td></td>
                        <td><b>${Math.round(this.commissionTotal).toFixed(0)}</b></td>
                        <td><b>${Math.round(this.totalBalance).toFixed(0)}</b></td>
                        <td><b>${Math.round(this.sumQuantity).toFixed(0)}</b></td>
                        <td><b>${Math.round(this.total).toFixed(0)}</b></td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
              </div>
            </div>
          </div>
<P class="page-break" style="page-break-after: always;clear: both;">
`;
       
        counter = counter + 1;
        if (counter == totalCounter) {
          let printContents, popupWin;
       //   printContents = document.getElementById('print-section').innerHTML;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
          popupWin.document.open();

          popupWin.document.write(`<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8"/>
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
        <title>Order Detail</title>
          <style>
            body{font-family:Arial!important}
            table{font-family:Arial!important;width:100%!important;max-width:100%!important;border: 1px solid #ddd!important;}
            .checkoutProductImage{width: 55px !important;height: auto !important;margin: 8px !important;vertical-align: middle;}
            table th, table td {vertical-align: middle !important;padding: 10px;border-bottom: 1px solid #ddd!important;text-align:left!important}
            table th{background-color:#fafafa!important}
            a{text-decoration:none!important;}
            .invoice-img-show{display: block;}

.manage-purchase-order-table tr th:first-child, .manage-purchase-order-table tr td:first-child {
  text-align: center !important;
}
.manage-purchase-order-table tr td:first-child label {
    margin-bottom: 0;
  }

          </style>
<style>
@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
</style>
    </head>
    <body onload="window.print();window.close()" style="padding:0;margin:0;font-family:Arial;font-size:12px;color:#000; line-height:20px;">
`+ text + `
    </body>
</html>
`);
          popupWin.document.close();

        }

        });
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/order-components/purchase-orders/purchase-orders.component.ts